import angular from 'angular';
// eslint-disable-next-line import/no-named-as-default
import assetDataService from '../data/asset.data.service';
import praDataService from '../data/pra.data.service';
import { default as riskSharedModelService } from './risk.sharedModel.service';
import { default as assetSharedModelService } from './asset.sharedModel.service';
import ISharedModelService from './ISharedModel.service';

// let _$filter;
let _assetDataService;
let _praDataService;
let _assetSharedModelService;
let _riskSharedModelService;

class praSharedModelService extends ISharedModelService {
  constructor(
    $filter,
    assetDataService,
    praDataService,
    assetSharedModelService,
    riskSharedModelService,
  ) {
    super('am');
    // _$filter = $filter;
    _assetDataService = assetDataService;
    _assetSharedModelService = assetSharedModelService;
    _riskSharedModelService = riskSharedModelService;
    _praDataService = praDataService;

    this.residualRiskLevelClassMappings = {
      4: 'status-tier-bar--bad',
      3: 'status-tier-bar--caution',
      2: 'status-tier-bar--good',
      1: 'status-tier-bar--great',
    };

    this.riskAppetiteClassMappings = {
      4: 'status-tier-bar--bad',
      3: 'status-tier-bar--caution',
      2: 'status-tier-bar--good',
      1: 'status-tier-bar--great',
    };


    console.log('app.services.praSharedModelService created');
  }

  /** ********************************************************************************************
   *  ********************************************************************************************
   *  ********************************************************************************************
   * CRUD Operations
   *
   */


  _initPage(getNew) {
    // eslint-disable-next-line max-len
    if (_assetSharedModelService.AssetCriticalities && _assetSharedModelService.AssetCriticalities.length > 0 && _riskSharedModelService.RiskOnsets && _riskSharedModelService.RiskOnsets.length > 0
    && !getNew) {
      return Promise.resolve();
    }
    return _assetDataService.initAssetAdmin(true).then((initAssetAdminResponse) => {
      const assetInitData = initAssetAdminResponse.data.CustomerAssetAdministrationInitData;

      if (assetInitData.AssetCriticalities) {
        const assetCriticalities = assetInitData.AssetCriticalities.result;
        _assetSharedModelService.AssetCriticalities = assetCriticalities;
      }

      if (assetInitData.AssetDataTypes) {
        const assetDataTypes = assetInitData.AssetDataTypes.result;
        _assetSharedModelService.AssetDataTypes = assetDataTypes;
      }

      if (assetInitData.AssetDataUses) {
        const assetDataUses = assetInitData.AssetDataUses.result;
        _assetSharedModelService.AssetDataUses = assetDataUses;
      }

      if (assetInitData.AssetTypes) {
        const assetTypes = assetInitData.AssetTypes.result;
        _assetSharedModelService.AssetTypes = assetTypes;
      }


      const riskInitData = initAssetAdminResponse.data.CustomerRiskAdministrationInitData;

      if (riskInitData.RiskOnsets) {
        const riskOnsets = riskInitData.RiskOnsets.result;
        _riskSharedModelService.RiskOnsets = riskOnsets;
      }

      if (riskInitData.RiskForewarnings) {
        const riskForewarnings = riskInitData.RiskForewarnings.result;
        _riskSharedModelService.RiskForewarnings = riskForewarnings;
      }

      if (riskInitData.RiskDurations) {
        const riskDurations = riskInitData.RiskDurations.result;
        _riskSharedModelService.RiskDurations = riskDurations;
      }

      if (riskInitData.RiskDataConfidentialities) {
        const riskDataConfidentialities = riskInitData.RiskDataConfidentialities.result;
        _riskSharedModelService.RiskDataConfidentialities = riskDataConfidentialities;
      }

      if (riskInitData.RiskDataIntegrities) {
        const riskDataIntegrities = riskInitData.RiskDataIntegrities.result;
        _riskSharedModelService.RiskDataIntegrities = riskDataIntegrities;
      }

      if (riskInitData.RiskDataAvailabilities) {
        const riskDataAvailabilities = riskInitData.RiskDataAvailabilities.result;
        _riskSharedModelService.RiskDataAvailabilities = riskDataAvailabilities;
      }

      if (riskInitData.RiskDirections) {
        const riskDirections = riskInitData.RiskDirections.result;
        _riskSharedModelService.RiskDirections = riskDirections;
      }

      if (riskInitData.RiskTrendings) {
        const riskTrendings = riskInitData.RiskTrendings.result;
        _riskSharedModelService.RiskTrendings = riskTrendings;
      }

      if (riskInitData.RiskAssessmentFrequencies) {
        const riskAssessmentFrequencies = riskInitData.RiskAssessmentFrequencies.result;
        _riskSharedModelService.RiskAssessmentFrequencies = riskAssessmentFrequencies;
      }

      if (riskInitData.RiskProbabilities) {
        const riskProbabilities = riskInitData.RiskProbabilities.result;
        _riskSharedModelService.RiskProbabilities = riskProbabilities;
      }

      if (riskInitData.RiskClassifications) {
        const riskClassifications = riskInitData.RiskClassifications.result;
        _riskSharedModelService.RiskClassifications = riskClassifications;
      }

      if (riskInitData.CustomerRiskInherentSeverityLevels) {
        const customerRiskInherentSeverityLevels = riskInitData.CustomerRiskInherentSeverityLevels.result;
        _riskSharedModelService.CustomerRiskInherentSeverityLevels = customerRiskInherentSeverityLevels;
      }
      // const controlInitData = initAssetAdminResponse.data.CustomerControlAdministrationInitData;

      // if (controlInitData.RiskClassifications) {
      //   vm.riskClassifications = controlInitData.RiskClassifications.result;
      //   controlSharedModelService.RiskClassifications = vm.riskClassifications;
      // }
    });
  }

  getAssignedAssets(assessmentProcessId) {
    return _praDataService.getAssignedAssetsByProcess(assessmentProcessId)
      .then(response => response.data);
  }
}

praSharedModelService.$inject = [
  '$filter',
  'assetDataService', // eslint-disable-line no-shadow
  'praDataService',
  'assetSharedModelService',
  'riskSharedModelService',
];

export default angular.module('app.services.praSharedModelService', [
  assetDataService, // eslint-disable-line no-shadow
  praDataService,
  assetSharedModelService,
  riskSharedModelService,
])
  .service('praSharedModelService', praSharedModelService)
  .name;
